// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d1b9a169","679":"be523200","688":"fd3e3bdf"}[chunkId] + ".chunk.js";
};